import WidgetJobs from './WidgetJobs';
import WidgetOrders from './WidgetOrders';
import WidgetActivities from './WidgetActivities';

const Dashboard: React.FC = () => {
  return (
    <div className="sm:m-0 md:m-6 grid grid-cols-1 gap-3 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 overflow-y-auto overflow-x-hidden">
      <WidgetJobs isExpired />
      <WidgetJobs isExpiring />
      <WidgetOrders isExpired />
      <WidgetOrders isExpiring />
      <WidgetActivities />
    </div>
  );
};

export default Dashboard;
